export function buildJacketBlocks(generated = {}) {
  const hasTwoPieceSleeve = Boolean(generated.topSleevePath || generated.underSleevePath);

  return [
    { key: 'front', label: 'Front', path: generated.frontPath || '', enabled: Boolean(generated.frontPath) },
    { key: 'side', label: 'Side', path: generated.sidePath || '', enabled: Boolean(generated.sidePath) },
    { key: 'back', label: 'Back', path: generated.backPath || '', enabled: Boolean(generated.backPath) },
    { key: 'topSleeve', label: 'Top Sleeve', path: generated.topSleevePath || '', enabled: Boolean(generated.topSleevePath) },
    { key: 'underSleeve', label: 'Under Sleeve', path: generated.underSleevePath || '', enabled: Boolean(generated.underSleevePath) },
    { key: 'sleeve', label: 'Sleeve', path: generated.sleevePath || '', enabled: !hasTwoPieceSleeve && Boolean(generated.sleevePath) },
  ];
}
